/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Swedish
export default {
  'ai-mate.chat-error-banner.description': 'Din chatthistorik sparas i upp till 30 dagar.',
  'ai-mate.chat-error-banner.title': 'Starta ny chatt',
  'ai-mate.chat-error.description': 'Försök att <btn>läsa in chatten igen</btn>.',
  'ai-mate.chat-error.rate-limited-description': 'Du har nått högsta antalet förfrågningar. Försök igen senare.',
  'ai-mate.chat-error.rate-limited-title': 'För många förfrågningar',
  'ai-mate.chat-error.rovo-inactive-description':
    'Det verkar som att Rovo inte är aktiverat på webbplatsen. <link>Ställer in Rovo</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'Rovo är inaktivt',
  'ai-mate.chat-error.title': 'Vi vet inte vad som gick fel',
  'ai-mate.chat-input.file-close-icon-label': 'Ta bort fil',
  'ai-mate.chat-input.file-error-icon-label': 'Fel vid inläsning av fil',
  'ai-mate.chat-view.chat-item.chat-delete-label': 'Radera',
  'ai-mate.chat-view.chat-item.chat-options-for-conversation-button-label': 'Chattalternativ för {conversationName}',
  'ai-mate.chat-view.chat-item.chat-rename-label': 'Byt namn',
  'ai-mate.common.ui.expandable-section.collapse': 'Dölj',
  'ai-mate.common.ui.expandable-section.expand': 'Visa',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.cancel-button-label.non-final': 'Avbryt',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.conversation-not-found-failure-message.non-final':
    'Konversationen du försöker radera finns inte.',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-button-label.non-final': 'Radera',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-conversation-title.non-final':
    'Vill du radera konversationen "{name}"?',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.generic-failure-message.non-final':
    'Ett fel inträffade när vi försökte radera konversationen. Försök igen.',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.modal-body.non-final':
    'Är du säker på att du vill radera konversationen? Åtgärden kan inte ångras.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.cancel-button-label.non-final': 'Avbryt',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.channel-not-found-error-message.non-final':
    'Kanalen du försöker redigera finns inte.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.edit-name-label.non-final': 'Namn',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.generic-error-message.non-final':
    'Ett fel inträffade när vi försökte redigera konversationen. Försök igen.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.modal-title.non-final': 'Redigera konversation',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.name-is-same-error-message.non-final':
    'Namnet är detsamma som det nuvarande namnet.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.save-button-label.non-final': 'Spara',
  'ai-mate.conversation-list-view.accessible-search-results':
    '{results, plural, one {{results,number} resultat hittades} other {{results,number} resultat hittades}}',
  'ai-mate.conversation-list-view.back-button.label': 'Tillbaka',
  'ai-mate.conversation-list-view.close-chat-button.label': 'Stäng chatt',
  'ai-mate.conversation-list-view.header-title': 'Chatthistorik',
  'ai-mate.conversation-list-view.new-chat-button.label': 'Ny chatt',
  'ai-mate.conversation-list-view.no-chat': 'Inga resultat',
  'ai-mate.conversation-list-view.search-input.placeholder': 'Sök i chattar',
  'ai-mate.expander.hide-details': 'Dölj information',
  'ai-mate.expander.show-details': 'Visa mer information',
  'ai-mate.main-chat.close-chat-panel-button-label': 'Stäng chatt',
  'ai-mate.main-chat.maximize-chat-button-label': 'Helskärm',
  'ai-mate.main-chat.minimize-chat-button-label': 'Återställ vy',
  'ai-mate.main-chat.new-chat-button-label': 'Ny',
  'ai-mate.main-chat.new-chat-button-label-full-screen': 'Ny chatt',
  'conversation-assistant-button.rovo-chat-label': 'Rovo-chatt',
  'highlight-actions.rovo-chat-custom-prompt-submit-button.text': 'Skicka',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Fråga AI om detta',
  'highlight-actions.rovo-chat-explain-option.text': 'Förklara',
  'highlight-actions.rovo-chat-explain-prompt':
    'Förklara detta med en ny formulering och lägg till mer information, men använd ett lättbegripligt språk, korta meningar och ge exempel eller definitioner av tekniska termer som används i den ursprungliga formuleringen.',
  'highlight-actions.rovo-chat-find-resources-option.text': 'Hitta resurser',
  'highlight-actions.rovo-chat-find-resources-prompt':
    'Hitta endast resurser i organisationskunskapen som ger stöd till meddelandena.',
  'highlight-actions.rovo-chat-give-examples-option.text': 'Ge exempel',
  'highlight-actions.rovo-chat-give-examples-prompt':
    'Ge exempel på detta från organisationsresurser eller allmän kunskap. Om det saknas resurser att göra ett försök att ge ett metaforiskt exempel som hjälper en person att förstå.',
  'highlight-actions.rovo-chat-give-feedback-option.text': 'Ge feedback',
  'highlight-actions.rovo-chat-give-feedback-prompt':
    'Ge feedback genom att granska formuleringen. Kommentera ordval, grammatik och skiljetecken. Var positiv och entusiastisk men kom alltid med minst ett förslag på något som kan förbättras eller förändras.',
  'highlight-actions.rovo-chat-more-options.tooltip': 'Chattrekommendationer',
  'highlight-actions.rovo-chat-open-chat.tooltip': 'Öppna chatt',
  'highlight-actions.rovo-chat-summarize-option.text': 'Sammanfatta',
  'highlight-actions.rovo-chat-summarize-prompt':
    'Lyft fram de viktigaste punkterna från texten. Fokusera på viktig information och hoppa över onödiga detaljer. Ge en kortfattad översikt i ett enda stycke.',
  'highlight-actions.rovo-chat.button-text': 'Chatt',
  'highlight-actions.rovo-chat.button-text-ask-in-chat': 'Fråga i chatten',
  'highlight-actions.rovo-chat.placeholder-prompt': 'Ställ en fråga om detta.',
  'horizontal-scroll-container.scroll-left': 'Bläddra åt vänster',
  'horizontal-scroll-container.scroll-right': 'Bläddra åt höger',
  'rovo-chat.deep-research-spotlight.description':
    'Aktivera Djupgående efterforskning och ange en uppmaning. Rovo skapar en plan, genomför efterforskningar och tar fram en komplett rapport.',
  'rovo-chat.deep-research-spotlight.dismiss': 'Avfärda',
  'rovo-chat.file-upload-dropzone.drag-drop-message': 'Dra och släpp för att lägga till sammanhang',
  'rovo-chat.message-file.icon-label': 'Fil',
};
